class MapMath {
  // criar essa tabela no backend
  zoomToDistanceS(zoom) {
    let distance = [0, 240, 210, 90, 40.4, 20, 10, 5, 2.5, 1.25, 0.7, 0.35, 0.15, 0.075, 0.038, 0.02, 0.01];
    return zoom > 16 ? 0.005 : distance[zoom];
  }

  minZoomToDistance(zoom) {
    return this.zoomToDistanceS(this.zoomToArray(zoom)[0]);
  }

  // https://www.geodatasource.com/developers/javascript
  distanceFromPosition(newCenter, oldCenter) {
    let nlat = newCenter.lat, nlng = newCenter.lng % 180,
      olat = oldCenter.lat, olng = oldCenter.lng % 180;
    if ((nlat == olat) && (nlng == olng)) return 0;
    let radnlat = Math.PI * nlat / 180,
      radolat = Math.PI * olat / 180,
      theta = nlng - olng,
      radtheta = Math.PI * theta / 180,
      dist = Math.sin(radnlat) * Math.sin(radolat) + Math.cos(radnlat) * Math.cos(radolat) * Math.cos(radtheta)
    if (dist > 1) dist = 1;
    return Math.acos(dist) * 180 / Math.PI
  }

  zoomToArray(zoom) {
    if (zoom <= 4) {
      return [1, 2, 3, 4];
    }
    else if (zoom <= 7) {
      return [4, 5, 6, 7, 8, 9];
    }
    else if (zoom <= 12) {
      return [8, 9, 10, 11, 12, 13, 14, 15, 16];
    }
    else if (zoom <= 17) {
      return [12, 13, 14, 15, 16, 17, 18, 19];
    }
    else return [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
  }

  zoomGroupChanged(zoomSum) {
    // 9: 4 <-> 5; 15: 7 <-> 8; 25: 12 <-> 13; 35: 17 <-> 18
    return [9, 15, 25, 35].indexOf(zoomSum) >= 0
  }

// distanceInMeters(distance) {
//   return distance * 60 * 1609.344
// }

  point2LatLng(point, map, google) {
    let topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    let bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    let scale = Math.pow(2, map.getZoom());
    let worldPoint = new google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
    let latLng = map.getProjection().fromPointToLatLng(worldPoint);
    return { lat: latLng.lat(), lng: latLng.lng() };
  }
}

const mapMath = new MapMath();
export default mapMath;
